"use client";

import React from "react";
import "./HowPadamiHelps.css";

const HowPadamiHelps = () => {
  const helps = [
    {
      id: 1,
      title: "Partner with Padami",
      description:
        "Register with Padami and begin your journey as a business partner.",
      cta: "Get Started",
    },
    {
      id: 2,
      title: "Launch Your Own Platform",
      description:
        "Get your own business website from Padami and start promoting your brand.",
      cta: "Create Website",
    },
    {
      id: 3,
      title: "Enhance Product Value",
      description:
        "Use your website to enhance product value and offer a premium selling experience.",
      cta: "Optimize Now",
    },
    {
      id: 4,
      title: "Grow Your Sales",
      description:
        "All of this helps increase your profits and take your business to the next level.",
      cta: "Boost Revenue",
    },
  ];

  return (
    <section className="how-helps-section" id="how-helps">
      <div className="how-helps-container">
        <div className="how-helps-header">
          <h2 className="how-helps-title">
            How does Padami help grow your business?
          </h2>
          <p className="how-helps-subtitle">
            How about partnering with us to transform your business for the
            modern generation and achieve new goals?
          </p>
        </div>

        <div className="helps-grid">
          {helps.map((item, index) => (
            <div key={item.id} className={`help-card card-${index + 1}`}>
              <div className="ribbon top-ribbon">
                <span className="ribbon-text">{item.title}</span>
              </div>
              <div className="card-content">
                <p className="description">{item.description}</p>
              </div>
              <div className="ribbon bottom-ribbon">
                <span className="ribbon-text">{item.cta}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowPadamiHelps;
